"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Cell = _interopRequireDefault(require("../Body/Cell"));

var _utils = require("../../../utils");

var _PropTypes$shape2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function FooterCell(props) {
  var _props$column = props.column,
      hidden = _props$column.hidden,
      render = _props$column.render,
      className = _props$column.className,
      sortable = _props$column.sortable,
      filterable = _props$column.filterable,
      sorter = _props$column.sorter,
      data = props.data,
      item = props.item;
  if (hidden) return null;
  var classNameCell = (0, _utils.getClassNames)(className, {
    'cell-sortable': sortable || sorter
  }, {
    'cell-filterable': filterable
  });
  return /*#__PURE__*/_react.default.createElement("th", {
    role: "rowheader",
    className: classNameCell
  }, render ? render(item, data, 0) : (0, _Cell.default)(item));
}

FooterCell.propTypes = {
  row: _propTypes.default.shape((_PropTypes$shape2 = {}, _defineProperty(_PropTypes$shape2, _propTypes.default.string, _propTypes.default.any), _defineProperty(_PropTypes$shape2, "children", _propTypes.default.arrayOf(_propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.any)))), _PropTypes$shape2)),
  data: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.shape),
  column: _propTypes.default.shape({
    hidden: _propTypes.default.bool,
    render: _propTypes.default.func,
    sortable: _propTypes.default.bool,
    className: _propTypes.default.string,
    filterable: _propTypes.default.bool,
    sorter: _propTypes.default.func
  }),
  item: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.shape])
};
FooterCell.defaultProps = {
  row: {
    children: undefined
  },
  data: null,
  column: {
    hidden: false,
    render: undefined,
    className: undefined,
    sorter: undefined
  },
  item: null
};
var _default = FooterCell;
exports.default = _default;